export const _selector = `
  [href],
  button:not([disabled]):not([tabindex="-1"]),
  input:not([disabled]):not([tabindex="-1"]),
  select:not([disabled]):not([tabindex="-1"]),
  textarea:not([disabled]):not([tabindex="-1"]),
  [form-element]:not([disabled]):not([tabindex="-1"]),
  [tabindex]:not([tabindex="-1"])
`;
